import { useGetRelease } from '../../api/use-get-release';
import { ReleaseLayout } from '../../components/layout/release-layout';
import { useGetReleaseIdFromParams } from '../../hooks/use-get-release-id-from-params/use-get-release-id-from-params';
import { FeedbackForm } from '../../components/feedback-form/feedback-form';

export const PromoReleasePage = () => {
  const releaseId = useGetReleaseIdFromParams();
  const { data } = useGetRelease(releaseId, {
    withTracks: true,
  });

  return (
    <ReleaseLayout>
      {data && (
        <div className="text-default min-h-[70vh]">
          <h1 className="heading1 mb-8">
            {data.artist}: {data.title}
          </h1>

          <div className="flex flex-col lg:flex-row gap-8">
            <div className="basis-1/2 flex flex-col gap-8">
              {data.tracks && (
                <ul className="flex flex-col gap-4">
                  {data.tracks.map((item) => (
                    <li key={item.listenLink}>
                      <p className="text-default font-bold mb-2">
                        {item.title}
                      </p>
                      <div
                        className="p-2"
                        dangerouslySetInnerHTML={{
                          __html: item.listenLink,
                        }}
                      />
                    </li>
                  ))}
                </ul>
              )}
              <p
                dangerouslySetInnerHTML={{
                  __html: data.content,
                }}
              />
              {data.releaseDate && (
                <p className="text-lg">
                  <span className="font-bold">RELEASE DATE: </span>
                  {new Date(data.releaseDate).toISOString().split('T')[0]}
                </p>
              )}
            </div>
            <div className="basis-1/2">
              {releaseId && <FeedbackForm releaseId={releaseId} {...data} />}
            </div>
          </div>
        </div>
      )}
    </ReleaseLayout>
  );
};
